











































import { Component, Prop, Watch } from "vue-property-decorator";
import { CompanyDetailsModule } from "@/store/modules/companyDetails";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import RateCardPositionDto from "@/models/RateCardPositions/RateCardPositionDto";

@Component({
  name: "CompanyRateCardPositionEdit",
})
export default class extends GiganautVueDialog {
  
  public dialog = false;

  @Prop({required: true})
  rateCardPositionId: string;
  rateCardPosition: RateCardPositionDto = new RateCardPositionDto();
  
 @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      //We need to fetch the latest copy - passing this in as a prop means updated at becomes stale on send edit
      const rateCardPosition = CompanyDetailsModule.currentRateCard.positions.find((findRateCardPosition: RateCardPositionDto) => findRateCardPosition.id === this.rateCardPositionId);
      this.rateCardPosition = JSON.parse(JSON.stringify(rateCardPosition));
      }
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await CompanyDetailsModule.editRateCardPosition(this.rateCardPosition);
    this.dialog = false;
  }
}
